<div *ngIf="onlineStatus === 'offline'">
  <div class="ct-overlay">
    <div class="ct-modal">
      <img class="cm-icon" src="assets/icons/no-internet.svg" alt="no-internet" />
      <p class="cm-msg-one">
        {{ "Oops" | translate }}
      </p>
      <p class="cm-msg-two">
        {{ "NoInternetConnectionFound" | translate }}
      </p>
      <p class="cm-msg-three">
        {{ "CheckYourConnection" | translate }}
      </p>
    </div>
  </div>
</div>
